
import { Button} from '@/imports-files/components/confirmation-modal';
import  ComponentStyle from '@/styles/components/delete-candidate-modal/_index.module.scss';
import { closeJob}  from '@/imports-files/pages/clients/candidates/kanban';
import Modal from "@/components/common-modal/modal";

export function HiredModal({setHiredModal, router, job_id})
{
  return(
          <Modal
            type="confirmation"
            message={`You have successfully hired a candidate for this role. What do you want to do next?`}
            texts={{
              button1_text: "Archive Job",
              button2_text: "Continue Hiring",
            }}
            closeModal={() => closeJob(job_id, router)}
            btnAction={() => {
              setHiredModal(false)
            }}
          />
        )
} 

